import {signal} from "@preact/signals-core";
import {Signal} from "@preact/signals-react";
import {IChar} from "../_interfaces/IChar";

import defaultChar from "../_helper/defaultChar";

import {ICharMod} from "../_interfaces/ICharMod";
import {ICharThread} from "../_interfaces/iCharThread";
import {ICharDiscipline} from "../_interfaces/ICharDiscipline";
import {ICharMatrice} from "../_interfaces/ICharMatrice";
import {ICharSkill} from "../_interfaces/ICharSkill";
import {ICharTalent} from "../_interfaces/ICharTalent";
import {ICharArmor} from "../_interfaces/ICharArmor";
import {ICharWeapon} from "../_interfaces/ICharWeapon";
import {ICharBloodMagicItem} from "../_interfaces/ICharBloodMagicItem";
import {ICharPresets} from "../_interfaces/ICharPresets";
import {ICharLPChanges} from "../_interfaces/ICharLPChanges";
import {ICharCoinChanges} from "../_interfaces/ICharCoinChanges";
import {ICharDiary} from "../_interfaces/ICharDiary";
import {ICharNote} from "../_interfaces/ICharNote";
import {ICharMatriceSpell} from "../_interfaces/ICharMatriceSpell";
import {ICharInventarSpell} from "../_interfaces/ICharInventarSpell";
import {ICharGrimoireSpell} from "../_interfaces/ICharGrimoireSpell";
import {ICharThreadStep} from "../_interfaces/iCharThreadStep";

export const s_char: Signal<IChar> = signal(defaultChar);

export const s_char_lp_changes: Signal<ICharLPChanges[]> = signal([]);
export const s_char_coins_changes: Signal<ICharCoinChanges[]> = signal([]);
export const s_char_presets: Signal<ICharPresets[]> = signal([]);
export const s_char_diary: Signal<ICharDiary[]> = signal([]);
export const s_char_notes: Signal<ICharNote[]> = signal([]);
export const s_char_mods: Signal<ICharMod[]> = signal([]);
export const s_char_threads: Signal<ICharThread[]> = signal([]);
export const s_char_threadsteps: Signal<ICharThreadStep[]> = signal([]);
export const s_char_disciplines: Signal<ICharDiscipline[]> = signal([]);
export const s_char_matrices: Signal<ICharMatrice[]> = signal([]);
export const s_char_matricespells: Signal<ICharMatriceSpell[]> = signal([]);
export const s_char_grimoirespells: Signal<ICharGrimoireSpell[]> = signal([]);
export const s_char_inventarSpells: Signal<ICharInventarSpell[]> = signal([]);
export const s_char_skills: Signal<ICharSkill[]> = signal([]);
export const s_char_talents: Signal<ICharTalent[]> = signal([]);
export const s_char_armor: Signal<ICharArmor[]> = signal([]);
export const s_char_weapons: Signal<ICharWeapon[]> = signal([]);
export const s_char_bloodmagicitems: Signal<ICharBloodMagicItem[]> = signal([]);
















